import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/index';

import { AccountGuardService } from './services/guards/account-guard.service';
import { environment } from 'src/environments/environment';
import { DatastoreService } from 'src/app/services';
import { ArrivalStatusComponent } from './tabs/customizable-tabs/arrival-status/arrival-status.component';
import { LoadingComponent } from './404/loading/loading.component';
import { LoginComponent } from './tabs/login/login/login.component';
import { NoBookingComponent } from './tabs/custom-tabs/no-booking/no-booking.component';



const routes: Routes = [
  { path: '', redirectTo: '/404', pathMatch: 'full' },
  {
    path: ':site/:comp', component: LoginComponent, canActivate: [AuthGuard], data: {
    }
  },  
  {
    path: ':site/:comp/login', component: LoginComponent, canActivate: [AuthGuard], data: {
    }
  },  
  {
    path: ':site/:comp/noBooking', component: NoBookingComponent, canActivate: [AuthGuard], data: {
    }
  },  
  {
    path: ':site/:comp/arrival/:status', component: ArrivalStatusComponent, canActivate: [AuthGuard], data: {
    }
  },  
  {
    path: '404', loadChildren: () => {
      return import('./404/four-oh-four.module').then((m) => m.FourOhFourModule)
    }, data: {
    }
  },
  {
    path: ':site/:comp/404', loadChildren: () => {
      return import('./404/four-oh-four.module').then((m) => m.FourOhFourModule)
    }, data: {
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule {
  constructor(
    private dataStore: DatastoreService,
  ) { }
}
